import axios from "axios";
import { enqueueSnackbar } from "notistack";
import i18n from "i18next";
// Функция округления
export const decimalAdjust = (type, value, exp) => {
  if (typeof exp === "undefined" || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
    return NaN;
  }
  value = value.toString().split("e");
  value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
  value = value.toString().split("e");
  return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
};

// Проверка параметров URL
export const checkParams = (bankTransferId, bankAmount, setFunctions) => {
  if (!setFunctions) {
    console.error("setFunctions is not provided.");
    return;
  }
  const { setIsContinued, setIdbk, setShowBankTransfer, setDepositAmount } =
    setFunctions;
  if (bankTransferId) {
    setIsContinued(true);
    setIdbk(bankTransferId);
    setShowBankTransfer((prev) => !prev);
    setDepositAmount(bankAmount);
  }
};

// Копирование текста
export const handleCopy = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() =>
      enqueueSnackbar(i18n.t("depositBank.copy"), {
        autoHideDuration: 3000,
        variant: "success",
      })
    )
    .catch(() =>
      enqueueSnackbar(i18n.t("depositBank.errCopy"), {
        autoHideDuration: 3000,
        variant: "error",
      })
    );
};

// Преобразование данных криптовалют
export const transformCryptoData = (data) => {
  const result = [];
  for (let i = 1; i <= 5; i++) {
    if (data[`bankEnabled${i}`]) {
      result.push({
        [`bankTransferVar`]: data[`bankTransferVar${i}`],
        [`bankCardNumber`]: data[`bankCardNumber${i}`],
      });
    }
  }
  return result;
};

// Получение доступных криптовалют
export const fetchCoinsAndAddress = async (
  setAvailableCoins,
  setLoading,
  token
) => {
  setLoading(true);
  axios
    .get(`https://api-ru.fynex.cc/api/api/bank/avilable`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      setAvailableCoins(transformCryptoData(res.data));
      setLoading(false);
    });
};

// Получение текущего курса
export const getCourse = (setCursCb) => {
  axios
    .get(`https://api-ru.fynex.cc/api/api/current_coin/ruble`)
    .then((res) => {
      setCursCb(res.data);
    });
};

// Управление статусами банка
export const handleBankStatus = (idbk, setFunctions) => {
  const { setIsContinuedSS, setWalletbk, setBankTransferDepREKS, setQrCodeImage } =
    setFunctions;
  axios
    .get(
      `https://api-ru.fynex.cc/api/api/refill/bank/details/status?id=${idbk}`
    )
    .then((res) => {
      if (res.data.accepted === true) {
        setIsContinuedSS(true);
        setWalletbk(res.data.wallet);
        setBankTransferDepREKS(res.data);
        setQrCodeImage(res?.data?.qr_image)
      } else if (res.data.accepted === false) {
        setTimeout(() => handleBankStatus(idbk, setFunctions), 2000);
      }
    })
    .catch((err) => {
      console.error(err);
      setTimeout(() => handleBankStatus(idbk, setFunctions), 2000);
    });
};

// Отправка депозита
export const handleDeposit = (params) => {
  const {
    selectedCoin,
    depositAmount,
    selectedCoin2,
    cursCb,
    token,
    navigate,
    t,
    setIdbk,
    setIsContinuedSS,
    setIsContinued,
  } = params;
  console.log("====================================");
  console.log(params);
  console.log("====================================");
  if (
    !selectedCoin ||
    !depositAmount ||
    (selectedCoin === "Other" && !selectedCoin2)
  ) {
    enqueueSnackbar(t("depositBank.errSumOrBank"), {
      autoHideDuration: 3000,
      variant: "error",
    });
    return;
  }

  axios
    .post(
      `https://api-ru.fynex.cc/api/api/users/balance/refill/bank`,
      {
        value: depositAmount,
        card_type: selectedCoin === "Other" ? selectedCoin2 : selectedCoin,
        card_type_custom: "",
        owner_name: "string",
        owner_details: "string",
        coin: "USDT",
        coin_to: "USDT",
        balance_type: "main",
        value_rubles: decimalAdjust("floor", depositAmount * cursCb),
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((res) => {
      setIdbk(res.data);
      // setIsContinuedSS(true);
      setIsContinued(true);
      enqueueSnackbar(t("depositBank.formSendnotOnloadPage"), {
        variant: "success",
        className: "snacksuccess",
      });
      navigate(
        `../account/deposit?bankTransferId=${res.data}&amount=${depositAmount}`,
        {
          replace: true,
        }
      );
    })
    .catch((error) => {
      error.response.data.detail.map((errormsg) =>
        enqueueSnackbar(`${t("depositBank.err")}: ${errormsg.msg}`, {
          variant: "error",
          className: "snackerror",
        })
      );
    });
};
